import React, { useState, useEffect } from 'react';
import { Link, useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { baseUrl } from '../components/BaseUrl';
import { paystackUrl } from '../components/PaystackUrl';
import axios from 'axios';
import Swal from "sweetalert2";
import '../App.css';



const TrackDescription = () => {
  const [data, setData] = useState([]);
  const [trackName, setTrackName] = useState("");
  const [firstTask, setFirstTask] = useState("");
  const [secondTask, setSecondTask] = useState("");
  const [thirdTask, setThirdTask] = useState("");
  const [fourthTask, setFourthTask] = useState("");
  const [status, setStatus] = useState('');
  const [course, setCourses] = useState("");
  const [duration, setDuration] = useState("");
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [enrolling, setEnrolling] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    getTrack();
    // checkSubscription();
  }, []);

  const enrol = () => {
  const token = localStorage.getItem("codefussion-login-token");
      setEnrolling(true);
      setDisabled(true);
      const userData = {
        first_name: localStorage.getItem("codefussion-student-first-name"),
        last_name: localStorage.getItem("codefussion-student-last-name"),
        email: localStorage.getItem("codefussion-student-email"),
        track_enrolled: trackName,
        track_courses: course,
        track_duration: duration,
        task_one: firstTask,
        task_two: secondTask,
        task_three: thirdTask,
        task_four: fourthTask,
      };
      axios.post(`${baseUrl}enrol-student.php`, userData,
        { headers:
        { Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token
        }
      }).then((response) => {
         // console.log(response.data)
        if(response.data.message === "You cannot enrol for more than 2 courses"){
          setEnrolling(false);
          setDisabled(false);
          Swal.fire({
            title: "Limit Reached",
            text: "You cannot enrol for more than 2 courses at a time.",
            icon: "error",
            confirmButtonText: "OK",
            backdrop: `
            rgba(143, 70, 0, 0.3)
            url("")
            left top
            no-repeat
          `
          });
        }else if(response.data.message === "You have already enrolled for this course"){
          Swal.fire({
            title: "Enrollment Active",
            text: "You have already enrolled for this course.",
            icon: "error",
            confirmButtonText: "OK",
            backdrop: `
            rgba(143, 70, 0, 0.3)
            url("")
            left top
            no-repeat
          `
          });
          setEnrolling(false);
          setDisabled(false);
        }else if(response.data.message === "Enrolment successful."){
          let timerInterval
          Swal.fire({
          title: 'Enrolment Succcessful',
          icon: "success",
          html: 'Redirecting in <b></b> milliseconds.',
          timer: 1000,
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading()
            const b = Swal.getHtmlContainer().querySelector('b')
            timerInterval = setInterval(() => {
              b.textContent = Swal.getTimerLeft()
            }, 100)
          },
          willClose: () => {
            clearInterval(timerInterval)
          }
        }).then((result) => {
          if (result.dismiss === Swal.DismissReason.timer) {
            window.location.replace("/course-catalogue")
          }
        })
           setEnrolling(false);
           setDisabled(false);
        }else{
          // Swal.fire({
          //   title: "Error",
          //   text: "An error occurred. Please try again later.",
          //   icon: "error",
          //   confirmButtonText: "OK",
          //   backdrop: `
          //   rgba(143, 70, 0, 0.3)
          //   url("")
          //   left top
          //   no-repeat
          // `
          // });
          setEnrolling(false);
          setDisabled(false);
        }
      });
    };

    const checkSubscription = async () => {
      setLoading(true)
     axios.get(`${paystackUrl}customer/${localStorage.getItem("codefussion-student-email")}`,
      { headers:
        { Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer sk_live_0467bebf073f41642820b763ec059700b432deb4`
        }
      })
     .then(response => {
     response.data.data.subscriptions.map((item)=> {

         if(item.status == 'active'){
           setStatus('active')
         }else{
           localStorage.removeItem("codefussion-subscription-status")
           Swal.fire({
            title: "Inactive Subscription",
            text: "You do not have an subscription",
            icon: "error",
            confirmButtonText: "OK",
            backdrop: `
            rgba(143, 70, 0, 0.3)
            url("")
            left top
            no-repeat
          `
             }).then(() => {
             window.location.replace("/subscription-plans")
          })
          setLoading(false)
         }
       })
      })
     .catch((error) => {
       Swal.fire({
         title: "Error",
         text: "An error occurred. Please try again later or reload the page.",
         icon: "error",
         confirmButtonText: "OK",
         backdrop: `
         rgba(143, 70, 0, 0.3)
         url("")
         left top
         no-repeat
       `
       });
       setLoading(false);
      });
    }

  const getTrack = () => {
  const token = localStorage.getItem("codefussion-login-token");
      setLoading(true);
      const userData = {
        id: id,
      };
      axios.post(`${baseUrl}get-track-by-id.php`, userData,
        { headers:
        { Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token
        }
      }).then((response) => {
        if(response.data.status === 0){
          setLoading(false);
          Swal.fire({
            title: "Error!",
            text: "An error occurred. Please try again later.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }else{
          let data = [];
           response.data.map((item) => {
             setTrackName(item.track_name);
             setFirstTask(item.task_one);
             setSecondTask(item.task_two);
             setThirdTask(item.task_three);
             setFourthTask(item.task_four);
             setDuration(item.track_duration);
             item.track_courses.map((val) => {
               data.push(val)
               setCourses(data.join(", "))
             })
           })
           setData(response.data);
           setLoading(false);
        }
      });
    };

   const showCourse = () => {
     return data.map((item) => {
       return(
         <div className='mt-4 Schem'>
         <h1>{item.track_name}</h1>
         <p>{item.track_description}</p>

         <h3>Pre-requisite</h3>
         <p>{item.track_prerequisite}</p>

         <h3>Courses</h3>
         <p>{course}</p>

        <h3>Objectives</h3>
        <ol>
        <li>{item.first_course_objective}</li>
        <li>{item.second_course_objective}</li>
        <li>{item.third_course_objective}</li>
        <li>{item.fourth_course_objective}</li>
        <li>{item.fifth_course_objective}</li>
        </ol>

        <h3>Tasks</h3>
        <ol>
        <li>{item.task_one}</li>
        {item.task_two ? <li>{item.task_two}</li> : null }
        {item.task_three ?<li>{item.task_three}</li> : null}
        {item.task_four ?<li>{item.tassk_four}</li> : null }
        </ol>

        {localStorage.getItem("codefussion-subscription-status") === "active" ?

        <button disabled={disabled} onClick={()=>enrol()} className="btn btn-primary col-md-3 col-lg-3 col-sm-12" type="button">
        {enrolling ? (
          <Spinner animation="border" variant="light" size="sm" />
        ) : (
          "Start Enrolment"
        )}
        </button> :
        <Link to={`/subscription-plans`}><button className="btn btn-primary col-md-3 col-lg-3 col-sm-12" type="button">Subscribe</button></Link>
        }
       </div>
       )
     })
   }

  return (
    <div>
      {localStorage.getItem("codefussion-login-token") === null ? window.location.replace("/login") :
    <div>
    <div className="p-4 mb-4" >
    <Link to="/tracks"><i className="fas fa-circle-xmark float-end text-danger exit"></i></Link>
    </div>
    {loading ?  <center>
        <div className="loader-wrapper">
        <div className="loader">
        <div className="loader loader-inner"></div>
        </div>
        </div>
        </center> :
        <div className="container mt-4 mb-4">
        {showCourse()}
        </div>
       }
    </div>
     }
    </div>
  );
};

export default TrackDescription;
